export class ProFilters {
  static proStatus() {
    return (items, statuses) => {
      if (!items || items.length === 0) {
        return items;
      }
      if (!statuses) {
        return items;
      }
      let s;
      if (Array.isArray(statuses)) {
        s = statuses;
      } else {
        s = statuses.split(",");
      }
      if (s.length === 0 || !s[0]) {
        return items;
      }
      return items.filter((item) => s.some((status) => item.workflow.status === status));
    };
  }
}
